import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FJAnimationManager} from "fj-graph";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import _ from 'lodash'
import FJTextContainer from 'fj-components/FJTextContainer';
import FJLocalStore from "../../../store/FJLocalStore";
import FJConfig from "../../../config/FJConfig";
import styles from "../view/css/FJResourcesTextContainer.module.less";
import $ from 'jquery'
import FJUtil from "../../../util/FJUtil";
import FJPanelAnimation from '../../../common/component/FJPanelAnimation/FJPanelAnimation'
import TextSvg from '../../../icon/text-timeline.svg';
import FJMedia from "../../../store/FJMedia";

const titleObj = {
  simple: 'basic-text',
  dynamic: 'dynamic-text'
};

class FJResourcesTextContainer extends Component {
  constructor(props) {
    super(props);
    this.allResourcesText = _.cloneDeep(FJAnimationManager.allAnimations());
    this.allResourcesText.simple = this.allResourcesText.simple.slice(0, 4);
		this._resourceViewInfo = {
			width: 140,
			height: 88,
			space: 12,
			marginBottom: 16,
		};
		this._classes = {
			textListClasses: {
				textListBox: styles.text_box
			},
			textMoreClasses:{
				textMoreBox: styles.more_box,
				textMoreInnerBox: styles.inner
			},
			pageHeaderClasses: {
				listBox: styles.page_header_box,
				seeAllBox: styles.see_all,
				moreBox: styles.more_box,
				titleBox: styles.title,
				headerBox: styles.page_header,
			},
			pageHeaderBackClasses: {
				headerBox: styles.page_back_header,
				backBox: styles.back_box,
				titleBox: styles.title,
				backTextBox: styles.back
			},
			itemClasses:{
        resourceItem: styles.item,
				resourceItemActive: styles.item_active,
				inner: styles.item_inner,
				name: styles.name,
				addBtnBox: styles.add_box,
				addBtn: styles.add,
				refresh: styles.refresh_img,
			}
		};
		this._config = {
			addIconToolTip: FJLocalStore._('add-to-timeline')
		};
		this._texts = this._dealTextData(this.allResourcesText);
  };

  /**
   * @description 处理 FJAnimationManager.allAnimations()
   * @param data
   * @private
   */
  _dealTextData = (data) => {
    let {
      textAnimationPreviewPath,
      buildVersion,
    } = FJConfig;
    let tempData = JSON.parse(JSON.stringify(data));
    let obj = {};
    for ( let i in tempData ) {
      if (data.hasOwnProperty(i)) {
        let item = tempData[i] || [];
        item.forEach(text => {
          let name = text.name;
          text.title = FJLocalStore._(text.localName);
          text.url = i !== 'simple' ? textAnimationPreviewPath + '\/video\/' + name.replace(/\s+|-/g, '_') + '.mp4?v=' + buildVersion : '';
          text.thumbnail = textAnimationPreviewPath + '\/' + name.replace(/\s+|-/g, '_') + '.png?v=' + buildVersion
        });
        obj[FJLocalStore._(titleObj[i])] = item;
      }
    }
    return obj;
  };

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    this.props.onMediaDrag(e, data, callback, this._getDragNodeInTimeLine, {height: 26, zIndex: 10});
  };

  /**
   * @description 得到拖动background到时间轴的样式
   * @param selfRect
   * @returns {HTMLDivElement}
   * @private
   */
  _getDragNodeInTimeLine = (selfRect) => {
    let node = document.createElement('div');
    let child= document.createElement('div');
	  let textChild = document.createElement('span');
	  let img  = document.createElement('div');

	  $(img).append(TextSvg);
	  textChild.innerText = 'Enter Title Here';
	  $(child).append(img);

	  $(node).append(child);
	  $(node).append(textChild);

	  $(child).addClass(styles.img_child_box);
	  $(textChild).addClass(styles.span_child_box)

    $(node).addClass(styles.text_animation);
    $(node).addClass('u-ellipsis');

    $(node).addClass(styles.active);
    $(node).addClass(styles.drag_other_img);

    let backgroundColor = '#5767FB';
    let  backgroundImage = 'none';


    $(node).css({
      width: selfRect.width,
      height: selfRect.height,
      backgroundColor: backgroundColor,
      backgroundPosition: 'auto',
      backgroundImage: backgroundImage,
      borderColor: '#FF822C'
    });
    return node;
  };

  _allTooltip = () => {
    FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
  };

  _oneTooltip = (ele) => {
    FJUtil.oneTooltip(ele, 'bottom');
  };
  
  _render = () => {
    let {isShow} = this.props;
    let {doCancelChoose, onAddClick, onHandleClick, chooseMediaIdList} = this.props;
    this._action = this._action || {
      onAddClick: onAddClick,
      onHandleClick: onHandleClick,
      onMediaDrag: this._onMediaDrag,
      doCancelChoose: doCancelChoose
    };
    this._callback = this._callback || {
      allTooltip: this._allTooltip,
      oneTooltip: this._oneTooltip
    };
    return (
      <FJTextContainer isShow={isShow}
                       seeAllText={FJLocalStore._('see-all')}
                       backTitle={FJLocalStore._('back')}
                       allResourcesText={this._texts}
                       chooseMediaIdList={chooseMediaIdList}
                       action={this._action}
                       config={this._config}
                       callback={this._callback}
                       classes={this._classes}
                       resourceViewInfo={this._resourceViewInfo}
      />
    )
  };

  render() {
    let {isShow, direction} = this.props;
    return (
      <FJPanelAnimation active={isShow} direction={direction} render={this._render} />
    )
  }
}

const mapStateToProps = function (state) {
  return {
    chooseMediaIdList: state.media.chooseMediaIdList,
    direction: state.resource.direction,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    doCancelChoose: function () {
      dispatch(FJMediaAction.selectMediaAction('', 2, 0));
    },
    onHandleClick: function (id, type, rate) {
      dispatch(FJMediaAction.selectMediaAction(id, type, rate));
    },
    onAddClick: function (id, type) {
      dispatch(FJMediaAction.addToTimeLineAction(type, FJMedia.MediaFromType().LOCAL, id));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesTextContainer);
